// extracted by mini-css-extract-plugin
export default {"container":"Ox5TMGL5","bodyContainer":"Y6l1AE7p","labelItem":"pjg35pqF","tableContainer":"KHsbr9UN","footerContainer":"qH9tpXSs"};